const ONE_DAY = 1;
const FIFTEEN_DAYS = 15;
const FIRST_OF_MONTH = 1;
const MID_OF_MONTH = 16;

export { FIFTEEN_DAYS, FIRST_OF_MONTH, MID_OF_MONTH, ONE_DAY };
